import { createActionCreator } from '@reduxify/utils';

import { SET_PROJECT_CONFIG } from './constants';
import { IConfigState } from './types';

export const setProjectConfig =
  createActionCreator<IConfigState['projectConfig']>(SET_PROJECT_CONFIG);
